const initialState = {
  overlay: false,
  alertType: "",
  alertMessage: "",
  alertCountdown: 0
}

const state = initialState;

const mutations = {
  setOverlayStatus: (state, toggle) => {
    state.overlay = toggle;
  },
  setAlert: (state, options) => {
    state.alertType = options.type;
    state.alertMessage = options.message;
    state.alertCountdown =
      ["warning", "danger"].indexOf(options.type) !== -1 ? true : 5;
  },
  setAlertCountdown(state, value) {
    state.alertCountdown = value
  },
  resetAlert(state) {
    state.alertType = "";
    state.alertMessage = "";
    state.alertCountdown = 0;
  },
  setData(state, value) {
    state = value
  }
}

const actions = {
  setOverlay: ({ commit }, status) => {
    commit("setOverlayStatus", status);
  },
  setAlert: ({ commit }, options) => {
    commit("setAlert", options);
  },
  reset: ({ commit }) => {
    commit('setData', initialState);
  }
}


export default {
  state,
  mutations,
  actions,
  namespaced: true
}